class DrawerCaerProgressBar extends HTMLElement {
  constructor() {
    super();
    this.tier1Amount = parseFloat(this.dataset.tier1Amount) || 600;
    this.tier2Additional = parseFloat(this.dataset.tier2Additional) || 300;
    this.tier2Total = this.tier1Amount + this.tier2Additional;
    this.currentTotal = parseFloat(this.dataset.currentTotal) || 0;
  }

  connectedCallback() {
    this.updateBar();
    document.addEventListener('cart:updated', () => this.fetchAndUpdate());
  }

  async fetchAndUpdate() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      this.currentTotal = cart.total_price / 100;
      this.updateBar();
    } catch (err) {
      console.warn('Cart fetch failed:', err);
    }
  }

  updateBar() {
    const title = this.querySelector('.dc-progress-bar__title');
    const subtitle = this.querySelector('.dc-progress-bar__subtitle');
    const tier1Fill = this.querySelector('[data-tier="1"] .dc-progress-bar__progress-fill');
    const tier2Fill = this.querySelector('[data-tier="2"] .dc-progress-bar__progress-fill');
    const tier1Progress = Math.min((this.currentTotal / this.tier1Amount) * 100, 100);
    const tier2Progress = this.currentTotal > this.tier1Amount
      ? Math.min(((this.currentTotal - this.tier1Amount) / this.tier2Additional) * 100, 100)
      : 0;

    tier1Fill.style.width = `${tier1Progress}%`;
    tier2Fill.style.width = `${tier2Progress}%`;

    if (this.currentTotal >= this.tier2Total) {
      title.textContent = this.dataset.tier2UnlockedTitle;
      subtitle.innerHTML = this.dataset.tier2UnlockedSubtitle;
    } else if (this.currentTotal >= this.tier1Amount) {
      title.textContent = this.dataset.tier1UnlockedTitle;
      const remaining = this.tier2Total - this.currentTotal;
      subtitle.innerHTML = this.dataset.tier1UnlockedSubtitle.replace('{{remaining}}', `${remaining.toFixed(2)}`);
    } else {
      title.textContent = this.dataset.initialTitle;
      subtitle.innerHTML = this.dataset.initialSubtitle;
    }
  }
}

customElements.define('dc-progress-bar', DrawerCaerProgressBar);